import { get, set, clear, deleteBy } from "./IndexedDBApi";
import {
  ASSOCIATED_REQUESTS,
  DEFAULT_EXPIRY_TIME,
  CACHE_EXPIRY_TIMES,
} from "./IDBCacheConstants";

const genKey = (reqData, uid, fn) => {
  return `${fn}_${uid}_${JSON.stringify(reqData)}`;
};

export const setCache = async (reqData, uid, fn, resData) => {
  const obj = {
    data: resData,
    date: Date.now(),
    key: genKey(reqData, uid, fn),
    fn,
    uid,
    expires: CACHE_EXPIRY_TIMES.get(fn) || DEFAULT_EXPIRY_TIME,
  };
  return await set(obj);
};

export const getCache = async (reqData, uid, fn) => {
  const res = await get(genKey(reqData, uid, fn));
  if (!res) {
    return res;
  }
  return Date.now() - res.date < res.expires ? res.data : null;
};

export const clearCache = async () => await clear();

export const clearAssociatedCaches = async (fn) => {
  ASSOCIATED_REQUESTS.has(fn) && deleteBy("fn", ASSOCIATED_REQUESTS.get(fn));
};
